import { handleActions } from 'redux-actions';
import {
  fetchMensagensRequest,
  fetchMensagensSuccess,
  fetchMensagensError,
  getMensagemRequest,
  getMensagemSuccess,
  getMensagemError,
  createMensagemRequest,
  createMensagemSuccess,
  createMensagemError,
  updateMensagemRequest,
  updateMensagemSuccess,
  updateMensagemError,
  newMensagemRequest,
  fetchMensagensStatsRequest,
  fetchMensagensStatsSuccess,
  fetchMensagensStatsError,
} from '../actions/mensagensActions';

const defaultState = {
  mensagens: [],
  totalPages: 0,
  mensagem: {},
  count: 0,
  isFetching: false,
  error: null,
};

export default handleActions(
  {
    [fetchMensagensRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [fetchMensagensSuccess](state, { payload }) {
      return {
        ...state,
        mensagens: payload.docs,
        totalItems: payload.totalDocs,
        totalPages: payload.totalPages,
        isFetching: false,
        error: null,
      };
    },
    [fetchMensagensError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
    [getMensagemRequest](state) {
      return {
        ...state,
        mensagem: {},
        isFetching: true,
        error: null,
      };
    },
    [getMensagemSuccess](state, { payload }) {
      return {
        ...state,
        mensagem: payload,
        isFetching: false,
        error: null,
      };
    },
    [getMensagemError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
    [createMensagemRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [createMensagemSuccess](state, { payload }) {
      return {
        ...state,
        mensagem: payload,
        isFetching: false,
        error: null,
      };
    },
    [createMensagemError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
    [updateMensagemRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [updateMensagemSuccess](state, { payload }) {
      return {
        ...state,
        mensagem: payload,
        isFetching: false,
        error: null,
      };
    },
    [updateMensagemError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
    [newMensagemRequest](state, { payload }) {
      return {
        ...state,
        mensagem: '',
        isFetching: false,
        error: payload,
      };
    },
    [fetchMensagensStatsRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [fetchMensagensStatsSuccess](state, { payload }) {
      return {
        ...state,
        count: payload.countMensagens,
        isFetching: false,
        error: null,
      };
    },
    [fetchMensagensStatsError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
  },
  defaultState
);
